'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('style-inject');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styleInject__default = /*#__PURE__*/_interopDefaultLegacy(styleInject);

var css_248z = ".Thumbnail-module_thumbnail__-euUZ{background-position:50%;background-size:cover;border-radius:4px;display:inline-block;height:5rem;margin:0 auto;width:5rem}";
var styles = {"thumbnail":"Thumbnail-module_thumbnail__-euUZ"};
styleInject__default["default"](css_248z);

exports["default"] = styles;
